import { useNavigate, useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../../appRedux/actions/CoreServicesAction";
import { useEffect, useRef, useState } from "react";
import Url from "../../../apiCall/UrlConfig";
import {
  Button,
  ConfigProvider,
  List,
  Popconfirm,
  Radio,
  message,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import CustomButton from "../../../component/CustomButton";
import { FaRegHand } from "react-icons/fa6";
import { RxCrosshair2 } from "react-icons/rx";

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const PROBLEM_COLORS = {
  Bone: "#0000FF59",
  Sinus: "#FFFF0059",
};

const CbctSegmentAnalysis = (props) => {
  const { id } = useParams();
  const navigate = useNavigate();

  const SvgRef = useRef(null);

  const [_Photo, setPhoto] = useState(null);
  const [listSegment, setListSegment] = useState([]);
  const [currentPoints, setCurrentPoints] = useState([]);
  const [problemType, setProblemType] = useState("Bone");
  const [editMode, setEditmode] = useState(false);

  useEffect(() => {
    GetImage();
  }, []);

  const GetImage = async () => {
    const res = await props.actions.CallCoreServicesActionWithToken(
      Url.GetCbctSegment,
      { id: parseInt(id) }
    );

    if (res.hasError) {
      message.error(res.message);
      return;
    }

    const data = res?.data;
    setPhoto(data?.image);

    if (data?.analyses?.length > 0) {
      const segments = data.analyses.map((a) => ({
        uid: uuidv4(),
        problem: a.problem,
        paths: (a.cbctSegmentAnalysisPaths || []).map((p) => ({
          x: p.x,
          y: p.y,
        })),
      }));
      setListSegment(segments);
    }
  };

  const onClickSvg = (event) => {
    if (editMode) return;
    const svgRect = SvgRef.current.getBoundingClientRect();
    const x = event.clientX - svgRect.left;
    const y = event.clientY - svgRect.top;
    setCurrentPoints((prev) => [...prev, { x, y }]);
  };

  const onSaveSegment = () => {
    if (currentPoints.length < 3) {
      message.warning("حداقل ۳ نقطه برای یک سگمنت لازم است");
      return;
    }
    setListSegment((prev) => [
      ...prev,
      { uid: uuidv4(), problem: problemType, paths: [...currentPoints] },
    ]);
    setCurrentPoints([]);
  };

  const _onClickSubmit = async () => {
    const body = listSegment.map((seg) => ({
      imageId: parseInt(id),
      problem: seg.problem,
      paths: seg.paths.map((p) => ({ x: p.x, y: p.y })),
    }));

    const res = await props.actions.CallCoreServicesActionWithToken(
      Url.SaveCbctSegment,
      body
    );

    if (res.hasError) {
      message.error(res.message);
      return;
    }
    message.success(res.message || "ذخیره شد");
    navigate(-1);
  };

  const getColor = (problem) => PROBLEM_COLORS[problem] || "#FF000059";

  const renderSvgContent = () => {
    const output = [];

    listSegment.forEach((seg) => {
      const points = seg.paths.map((p) => `${p.x},${p.y}`).join(" ");
      const strokeColor = getColor(seg.problem).slice(0, 7);
      output.push(
        <polygon
          key={seg.uid}
          points={points}
          style={{
            fill: getColor(seg.problem),
            stroke: strokeColor,
            strokeWidth: 1,
          }}
        />
      );
    });

    if (currentPoints.length > 0) {
      const points = currentPoints.map((p) => `${p.x},${p.y}`).join(" ");
      output.push(
        <polyline
          key="current-drawing"
          points={points}
          style={{ fill: "none", stroke: "green", strokeWidth: 2 }}
        />
      );
      currentPoints.forEach((p, i) => {
        output.push(
          <circle key={`pt-${i}`} cx={p.x} cy={p.y} r={3} fill="green" />
        );
      });
    }

    return output;
  };

  const renderSidebar = () => (
    <div dir="ltr" className="sidebar">
      <div>
        <div className="margin-horizontal10 flex-row justify-between">
          <FaRegHand
            style={{ cursor: "pointer" }}
            onClick={() => setEditmode(true)}
            color={editMode ? "green" : "black"}
          />
          <RxCrosshair2
            style={{ cursor: "pointer" }}
            onClick={() => setEditmode(false)}
            color={!editMode ? "green" : "black"}
          />
        </div>
        <div className="margin-horizontal10" style={{ marginTop: 8 }}>
          Labels
        </div>
        <ConfigProvider direction="ltr">
          <List
            split
            size="small"
            dataSource={listSegment}
            renderItem={(item) => (
              <div className="margin-horizontal10 sliderText">
                <div
                  style={{
                    backgroundColor: getColor(item.problem),
                    marginTop: 2,
                  }}
                  className="flex-row justify-between"
                >
                  <div className="imgdragdisable margin-horizontal10">
                    {item.problem}
                  </div>
                  <div className="margin-horizontal10">
                    <Popconfirm
                      title="Delete"
                      description="Are you sure to delete this segment?"
                      onConfirm={() =>
                        setListSegment((prev) =>
                          prev.filter((o) => o.uid !== item.uid)
                        )
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <DeleteOutlined style={{ cursor: "pointer" }} />
                    </Popconfirm>
                  </div>
                </div>
              </div>
            )}
          />
        </ConfigProvider>
      </div>
      <div>
        <CustomButton
          onClick={_onClickSubmit}
          title="Submit"
          isLoading={
            props.coreData[Url.SaveCbctSegment]?.[Url.action]?.isFetching
          }
        />
      </div>
    </div>
  );

  return (
    <div dir="ltr">
      <div className="flex-row" style={{ position: "relative" }}>
        {renderSidebar()}
        {_Photo !== null && (
          <div
            className="text-center"
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                alignSelf: "center",
                position: "relative",
                width: _Photo?.imageWidth,
                height: _Photo?.imageHeight,
              }}
            >
              <svg
                ref={SvgRef}
                style={{ zIndex: 1, position: "absolute", top: 0, left: 0 }}
                width={_Photo?.imageWidth}
                height={_Photo?.imageHeight}
                onClick={onClickSvg}
              >
                {renderSvgContent()}
              </svg>
              <img
                className="imgdragdisable"
                src={ImagePreAddress + _Photo?.imageUrl}
                style={{
                  width: _Photo?.imageWidth,
                  height: _Photo?.imageHeight,
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 0,
                }}
                alt="cbct"
              />
            </div>

            <div style={{ marginTop: 10 }}>
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                size="small"
                value={problemType}
                onChange={(e) => setProblemType(e.target.value)}
              >
                <Radio style={{ width: 90 }} value="Bone">
                  استخوان
                </Radio>
                <Radio style={{ width: 90 }} value="Sinus">
                  سینوس
                </Radio>
              </Radio.Group>
            </div>

            <div
              style={{
                marginTop: 10,
                marginBottom: 2,
                display: "flex",
                gap: 8,
                justifyContent: "center",
              }}
            >
              <Button onClick={() => setCurrentPoints([])}>Reset</Button>
              <Button
                type="primary"
                disabled={currentPoints.length < 3}
                onClick={onSaveSegment}
              >
                Save Segment
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});
const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(CbctSegmentAnalysis);
